var _path, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _polygon3, _rect6, _ellipse, _ellipse2, _circle3, _circle4, _path7, _ellipse3, _ellipse4, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4af97e3-409c-4914-b906-15bd03bcf69c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 808.3072,
    height: 759.92455,
    viewBox: "0 0 808.3072 759.92455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "game_world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M665.53842,566.71628v263.246H1004.1536v-263.246Zm294.39781,70.3986h-26.2257V610.88911h26.2257Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 496.67855,
    width: 441.29204,
    height: 68.81534,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 593.89388,
    width: 441.29204,
    height: 68.81534,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 691.1092,
    width: 441.29204,
    height: 68.81534,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.64611,
    y: 164.61722,
    width: 21.84614,
    height: 28.39998,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 838.12293,
    y: 453.11635,
    width: 21.84614,
    height: 28.39998,
    transform: "translate(1120.51594 -451.76739) rotate(90)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "310.172 593.894 441.292 593.894 441.292 662.709 270.444 662.709 310.172 593.894",
    fill: "#e2e2e2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.038 691.109 441.292 691.109 441.292 759.925 214.311 759.925 254.038 691.109",
    fill: "#e2e2e2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520.12079,408.27932c-1.88053-1.88511-3.74726-3.83232-5.54891-5.7881l1.95463-1.80078c1.77779,1.93131,3.61976,3.85291,5.4749,5.71252Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.01188,390.024c-3.33467-4.28305-6.52882-8.75567-9.49325-13.29435l2.22366-1.4536c2.92555,4.47747,6.07649,8.89037,9.36628,13.11535Zm-17.85167-27.32984c-2.5791-4.77079-4.98983-9.7101-7.16589-14.67941l2.43437-1.06613c2.14613,4.90308,4.52414,9.77536,7.06832,14.48153Zm-13.0901-29.90189c-1.75375-5.12267-3.31794-10.38953-4.65073-15.65539l2.57622-.65217c1.31407,5.19614,2.85815,10.39289,4.58809,15.44682Zm-5.3918-32.0811-2.6195.44119c-.90176-5.35682-1.59232-10.80717-2.05289-16.19877l2.64774-.226C466.10775,290.04776,466.7889,295.42527,467.67831,300.71114Zm-2.73308-32.07865-2.65687.0071c-.0142-5.42342.19852-10.91367.63251-16.31838l2.649.21241C465.14106,257.866,464.93128,263.28235,464.94523,268.63249Zm2.58169-32.09108-2.6212-.4318c.88194-5.35295,2.00034-10.73691,3.324-16.00186l2.57692.64775C469.5004,225.94972,468.397,231.26077,467.52692,236.54141ZM823.281,159.64747c-2.97121-4.44357-6.1682-8.82119-9.50289-13.01175l2.07929-1.65435c3.38008,4.24788,6.62091,8.68508,9.63216,13.189Zm-347.901,45.649-2.51436-.858c1.7518-5.13076,3.7407-10.255,5.91136-15.23126l2.4348,1.06224C479.07061,195.17925,477.10815,200.235,475.38,205.29644Zm327.853-70.84479c-3.66449-3.89649-7.53771-7.69-11.512-11.27446l1.78-1.97325c4.028,3.63356,7.95344,7.47846,11.667,11.42758ZM488.259,175.77329l-2.34054-1.25877c2.57025-4.77777,5.36926-9.50646,8.32094-14.05648l2.22854,1.44549C493.55607,166.393,490.79389,171.05913,488.259,175.77329Zm291.06412-62.89c-4.25506-3.2483-8.69632-6.359-13.20087-9.24611l1.434-2.23688c4.565,2.92634,9.06648,6.07894,13.37873,9.37039Zm-273.53921,35.87-2.10286-1.623c3.31306-4.29263,6.84575-8.5014,10.49977-12.50894l1.96326,1.7899C512.5386,140.36586,509.05313,144.518,505.78386,148.75328ZM752.2093,95.50262c-4.72782-2.50984-9.618-4.8543-14.53361-6.96728l1.049-2.44151c4.98271,2.14233,9.93831,4.51779,14.73014,7.06155ZM527.47833,124.963l-1.8095-1.945c3.973-3.69575,8.14557-7.26809,12.40252-10.61821l1.64284,2.08811C535.51456,117.79263,531.39822,121.31715,527.47833,124.963ZM722.61884,82.78526c-5.08186-1.70375-10.29028-3.214-15.4804-4.48866l.63379-2.58084c5.261,1.29271,10.54011,2.8237,15.691,4.54982ZM552.7707,105.05962l-1.46536-2.2161c4.52333-2.98922,9.22559-5.82464,13.9767-8.427l1.276,2.33053C561.87143,99.31386,557.23243,102.11068,552.7707,105.05962ZM691.33934,75.10267c-5.283-.84124-10.66929-1.471-16.00873-1.87133l.19919-2.64906c5.41179.40554,10.87167,1.0436,16.22762,1.89655ZM580.99751,89.60093l-1.07813-2.42811c4.94964-2.19935,10.05919-4.2201,15.1854-6.0069l.87439,2.509C590.92169,85.43788,585.88154,87.43139,580.99751,89.60093Zm78.22471-16.90648c-5.33991.043-10.75482.31059-16.09406.79609l-.24024-2.64632c5.41141-.49148,10.90014-.76334,16.31269-.80649Zm-47.82413,6.3092-.66594-2.57224c5.242-1.35726,10.6294-2.51859,15.96465-3.44658l.45544,2.61807C621.88324,76.51814,616.57163,77.66486,611.39809,79.00365Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M835.463,180.58292c-1.177-2.34827-2.41838-4.70464-3.69029-7.00359l2.3245-1.28674c1.28924,2.33063,2.548,4.7193,3.74049,7.09962Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M906.7198,829.96227,782.57915,614.95253l-27.85383-48.23625L690.41027,455.301l-31.97184-55.369-31.97185,55.369-64.315,111.41532-27.85383,48.23625L522.4134,635.53162h114.725V566.71628h28.4v263.246Zm-159.28869-110.837A15.94179,15.94179,0,1,1,731.48932,735.067,15.96007,15.96007,0,0,1,747.43111,719.12524Zm-91.95386-209.4088L637.58912,490.5382l19.17824-17.88813,17.88813,19.17824Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#e2e2e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 442.23692,
    cy: 273.92007,
    r: 13.28482,
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M653.37436,151.76816A131.07684,131.07684,0,1,0,806.87882,255.68475,131.07684,131.07684,0,0,0,653.37436,151.76816ZM641.09881,359.61179a15.94179,15.94179,0,1,1,12.63851-18.66947A15.96006,15.96006,0,0,1,641.09881,359.61179Zm88.32849-116.317-25.75225,4.96074-4.96075-25.75231,25.75225-4.96075Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.58614,
    cy: 360.73084,
    r: 86.29225,
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.258 478.9 148.461 474.23 156.828 420.366 182.624 425.036 174.258 478.9",
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 399.87381,
    y: 501.70269,
    width: 26.21537,
    height: 46.9692,
    transform: "translate(-95.68785 -135.2039) rotate(10.26106)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.29669,
    cy: 554.10593,
    rx: 8.1923,
    ry: 21.84614,
    transform: "translate(-472.49402 441.35533) rotate(-49.73894)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.77935,
    cy: 552.60699,
    rx: 8.1923,
    ry: 21.84614,
    transform: "translate(-489.2196 402.27494) rotate(-49.73894)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.62734,
    cy: 339.62325,
    r: 29.49229,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.74858,
    cy: 329.05184,
    r: 9.83076,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.36,336.89182c-1.29768-31.94668,26.23575-59.00572,61.49764-60.43807s64.89929,23.30439,66.197,55.25106S439.8408,370.91,404.5789,372.34239,336.65769,368.83849,335.36,336.89182Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#e2e2e2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.11149,
    cy: 415.04754,
    rx: 43.14613,
    ry: 13.5449,
    transform: "translate(-276.36496 48.39164) rotate(-12.9101)",
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.72306,
    cy: 443.21658,
    rx: 43.14613,
    ry: 13.5449,
    transform: "translate(-286.94037 11.2586) rotate(-12.9101)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.73233,464.77525A19.66152,19.66152,0,0,0,418.42646,471.78c1.93431-10.68509-6.32705-14.46611-17.01214-16.40042S381.66664,454.09016,379.73233,464.77525Z",
    transform: "translate(-195.8464 -70.03773)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterPage);
export default __webpack_public_path__ + "static/media/registerPage.98b0598a3b21fa75e669a451ca8104af.svg";
export { ForwardRef as ReactComponent };